<!--
 * @Author: FengXiao
 * @Date: 2020-07-01 22:08:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-14 10:55:45
-->
<template>
  <div id="app" :class="{ 'fixed-height': fixedHeight, 'yixi_international':international_show }">
    <top-bar v-if="!international_show"></top-bar>
    <keep-alive :exclude="excludeRouters">
      <router-view class="web-page-container" />
    </keep-alive>
    <bottom-area v-if="!international_show"></bottom-area>
    <mini-program-guide></mini-program-guide>
  </div>
</template>
<script>
import TopBar from '@/components/TheTopBar';
import BottomArea from '@/components/TheBottomArea';
import MiniProgramGuide from '@/components/MiniProgramGuide';
import { mapState } from 'vuex';

export default {
  components: {
    TopBar,
    BottomArea,
    MiniProgramGuide,
  },
  computed: {
    ...mapState(['fixedHeight', 'excludeRouters','international_show']),
  },
  mounted() {
    window.addEventListener(
      'hashchange',
      () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.replace(currentPath);
        }
      },
      false
    );
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  min-height: 100%;
  padding-top: 180px;
  box-sizing: border-box;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  &.fixed-height {
    height: 100vh;
    overflow: hidden;
  }
  .web-page-container {
    flex: 1;
  }
}
.yixi_international {
	padding: 0 !important;
}
@font-face {
  font-family: 'HYXinRenWenSong65W';
  src: url('https://alicdn.yixi.tv/font/HYXinRenWenSong65W.ttf') format('truetype');
  font-display: swap;
}
</style>
